import { I_QREditorFormTemplate } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrYoutubeValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "youtubeUrl",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("youtubeUrl", "required", data),
        },
        minLength: {
          value: 1,
          message: getRuleErrorMessage("youtubeUrl", "minLength", data),
        },
        pattern: {
          value: new RegExp(
            "^(?:https?:\\/\\/(?:www\\.)?|https:(?:\\/\\/)?)?(www\\.)?(youtube\\.com|youtu\\.be)\\/.+$"
          ),
          message: getRuleErrorMessage("youtubeUrl", "pattern", data),
        },
      },
    },
  ];
};
